import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model, OptionModel } from "../model";

export class DocumentTypeModel
  extends Model
  implements IModel<DocumentTypeModel>
{
  title: string = "";
  description: string = "";
  twoSides: boolean = false;
  onlyForPCD: boolean = false;
  onlyForMen: boolean = false;
  organizationId: string | undefined = undefined;
  companyGroupId: string | undefined = undefined;
  ocrFieldsSchema: string | null = null;

  static create(input: any): DocumentTypeModel {
    return ObjectMapper.deserialize<DocumentTypeModel>(
      DocumentTypeModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  toOption(): OptionModel {
    return { label: this.title, value: this.id } as OptionModel;
  }
}
